import React from 'react';

type AlertIconProps = {
    size?: number;
    color?: string;
    className?: string;
};

const AlertIcon: React.FC<AlertIconProps> = React.memo((props) => {
    const {size, color, className} = props;

    return (
        <svg className={className && className} width={size || '32'} height={size || '32'} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M13.72 5.14667L2.42669 24C2.19385 24.4032 2.07065 24.8604 2.06935 25.326C2.06804 25.7917 2.18868 26.2495 2.41926 26.654C2.64984 27.0586 2.98233 27.3957 3.38364 27.6318C3.78495 27.8679 4.24109 27.9949 4.70669 28H27.2934C27.759 27.9949 28.2151 27.8679 28.6164 27.6318C29.0177 27.3957 29.3502 27.0586 29.5808 26.654C29.8114 26.2495 29.932 25.7917 29.9307 25.326C29.9294 24.8604 29.8062 24.4032 29.5734 24L18.28 5.14667C18.0423 4.75481 17.7077 4.43082 17.3083 4.20598C16.9089 3.98113 16.4583 3.86301 16 3.86301C15.5417 3.86301 15.0911 3.98113 14.6918 4.20598C14.2924 4.43082 13.9577 4.75481 13.72 5.14667V5.14667Z"
                stroke={color || 'currentColor' || '#1E1E20'}
                strokeWidth="2.66667"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M16 12V17.3333" stroke={color || 'currentColor' || '#1E1E20'} strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M16 22.6667H16.0133" stroke={color || 'currentColor' || '#1E1E20'} strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
});

export default AlertIcon;
